import React from 'react';
import { CheckCircle } from 'lucide-react';
import { getPasswordChecks } from '../utils/passwordPolicy';

/**
 * Live-Anzeige der Passwort-Kriterien mit grünen Haken ("Länge-zuerst"-Regel).
 * Wird bei Registrierung, Passwort-Reset und Passwort-Ändern verwendet.
 *
 * Props:
 *  - password: aktuelles Passwort
 *  - confirmPassword: Bestätigungsfeld (nur relevant, wenn showMatch=true)
 *  - showMatch: zeigt zusätzlich "Passwörter stimmen überein"
 */
const RequirementItem = ({ met, children, indent = false }) => (
  <li
    className={`flex items-center gap-2 ${indent ? 'pl-4' : ''} ${
      met ? 'text-success' : 'text-muted-foreground'
    }`}
  >
    {met ? (
      <CheckCircle className="h-4 w-4 flex-shrink-0" />
    ) : (
      <div className="h-4 w-4 rounded-full border-2 border-border flex-shrink-0" />
    )}
    <span>{children}</span>
  </li>
);

const PasswordRequirements = ({ password = '', confirmPassword = '', showMatch = false }) => {
  const checks = getPasswordChecks(password, confirmPassword);

  return (
    <div className="bg-surface-raised p-4 rounded-xl border border-border">
      <p className="text-sm font-medium text-foreground/80 mb-3">Passwort-Anforderungen:</p>
      <ul className="space-y-2 text-sm">
        <RequirementItem met={checks.length12}>
          Mindestens 12 Zeichen <span className="text-xs opacity-80">— dann reicht das Passwort allein</span>
        </RequirementItem>

        <li className="text-xs text-muted-foreground/70 pl-1">oder bei kürzeren Passwörtern:</li>

        <RequirementItem met={checks.min8} indent>Mindestens 8 Zeichen</RequirementItem>
        <RequirementItem met={checks.letters} indent>Groß- und Kleinbuchstabe</RequirementItem>
        <RequirementItem met={checks.numberOrSpecial} indent>Zahl oder Sonderzeichen</RequirementItem>

        {showMatch && (
          <RequirementItem met={checks.match}>Passwörter stimmen überein</RequirementItem>
        )}
      </ul>
    </div>
  );
};

export default PasswordRequirements;
